import React from 'react';

import Grid from 'components/Grid';

import InfoItem from '../components/InfoItem';

const CameraInfo = ({ camera }) => {
  if (!camera) return null;

  return (
    <Grid gutter={[24, 24]} columns={2}>
      <InfoItem name="Camera ID " value={camera.camera_id} />
      <InfoItem name="Status" value={camera.is_active} />
      <InfoItem name="Count Mode" value={camera.count_mode} />
      <InfoItem name="Door ID" value={camera.door_id} />
      <InfoItem name="Brand" value={camera.brand} />
      <InfoItem name="Zone Code" value={camera.zone_code} />
      <InfoItem name="IP" value={camera.ip} />
      <InfoItem name="Door Distance" value={camera.door_distance} />
      <InfoItem name="User" value={camera.user} />
      <InfoItem name="Floor height" value={camera.floor_height} />
      <InfoItem name="Password" value={camera.password} />
    </Grid>
  );
};

export default CameraInfo;
